export default __webpack_public_path__ + "static/media/blog5.2599a6b1.svg";